export default __webpack_public_path__ + "static/IBMPlexSans-Medium-Cyrillic-c8fd85513c37eab1f030857619b8c3d3.woff2";